import React from 'react';

const Toaster = React.lazy(() => import('./views/notifications/toaster/Toaster'));
const Tables = React.lazy(() => import('./views/base/tables/Tables'));
const Alerts = React.lazy(() => import('./views/notifications/alerts/Alerts'));
const Badges = React.lazy(() => import('./views/notifications/badges/Badges'));
const Modals = React.lazy(() => import('./views/notifications/modals/Modals'));
const Colors = React.lazy(() => import('./views/theme/colors/Colors'));
const Typography = React.lazy(() => import('./views/theme/typography/Typography'));
const Widgets = React.lazy(() => import('./views/widgets/Widgets'));
const Users = React.lazy(() => import('./views/users/Users'));
const User = React.lazy(() => import('./views/users/User'));
const ChangePassword = React.lazy(() => import('./views/users/ChangePassword'));
const Dashboard = React.lazy(() => import('./views/dashboard/Dashboard'));
const DetailDevice = React.lazy(() => import('./views/dashboard/DetailDevice'));
const DetailDeviceNew = React.lazy(() => import('./views/dashboard/DetailDeviceNew'));
const Musers = React.lazy(() => import('./views/users/Musers')); 
const InstallationResult = React.lazy(() => import('./views/pages/login/ViewInstallation')); 
const Mcustomers = React.lazy(() => import('./views/customers/Mcustomers'));
const DeviceEDS = React.lazy(() => import('./views/device/eds/DeviceEDS'));
const LogDevice = React.lazy(() => import('./views/device/eds/detail/LogDevice'));
const DeviceGCS = React.lazy(() => import('./views/device/gcs/DeviceGCS'));
const LogDeviceGCS = React.lazy(() => import('./views/device/gcs/detail/LogDevice'));
const DeviceSearch = React.lazy(() => import('./views/device/search/DeviceSearch'));
const NewTicket = React.lazy(() => import('./views/tickets/NewTicket'));
const NewTicketReadyReserved = React.lazy(() => import('./views/tickets/NewTicketReadyReserved'));
const TicketProgress = React.lazy(() => import('./views/tickets/ProgressTicket'));
const TicketReporting = React.lazy(() => import('./views/tickets/Reporting'));
const CloseTicket = React.lazy(() => import('./views/tickets/CloseTicket'));
const TicketInfo = React.lazy(() => import('./views/tickets/detail/'));
const TestConnection = React.lazy(() => import('./views/pages/page404/Page404'));
const UploadDS = React.lazy(() => import('./views/ds/UploadDS'))
const ChartStatusToner = React.lazy(() => import('./views/tickets/detail/ChartStatusToner'))
const ChartStatusTonerGCS = React.lazy(() => import('./views/tickets/detail/ChartStatusTonerGCS'))
const ChartSample = React.lazy(() => import('./views/tickets/detail/MainChartExample'))
const SearchConsumable = React.lazy(() => import('./views/ds/SearchConsumable'))
const SearchConsumableGCS = React.lazy(() => import('./views/ds/SearchConsumableGCS'))
const SearchSNTonerDrum = React.lazy(() => import('./views/device/eds/SearchSNTonerDrum'))
//const Switches = React.lazy(() => import('./views/base/switches/Switches'))

const routes = [
  { path: '/', exact: true, name: 'Home' },
  { path: '/dashboard', name: 'Dashboard', component: Dashboard },
  // { path: '/detailDevice', name: 'Detail Device', component: DetailDevice },
  { path: '/detailDevice', name: 'Detail Device', component: DetailDeviceNew },
  { path: '/theme', name: 'Theme', component: Colors, exact: true },
  { path: '/theme/colors', name: 'Colors', component: Colors },
  { path: '/theme/typography', name: 'Typography', component: Typography },
  { path: '/notifications', name: 'Notifications', component: Alerts, exact: true },
  { path: '/notifications/alerts', name: 'Alerts', component: Alerts },
  { path: '/notifications/badges', name: 'Badges', component: Badges },
  { path: '/notifications/modals', name: 'Modals', component: Modals },
  { path: '/notifications/toaster', name: 'Toaster', component: Toaster },
  { path: '/widgets', name: 'Widgets', component: Widgets },
  { path: '/users', exact: true,  name: 'Users', component: Users },
  { path: '/users/:id', exact: true, name: 'User Details', component: User },
  { path: '/changepassword', exact: true,  name: 'ChangePassword', component: ChangePassword },
  { path: '/managementusers', exact: true,  name: 'Management users', component: Musers },
  { path: '/instalationresult', name: 'Instalation Result', component: InstallationResult },
  { path: '/management-customers', exact: true,  name: 'Management customers', component: Mcustomers },
  { path: '/deviceeds', exact: true,  name: 'EDS Device', component: DeviceEDS },
  { path: '/deviceeds/log/:sn', name: 'Log Device', component: LogDevice },
  { path: '/devicegcs', exact: true,  name: 'GCS Device', component: DeviceGCS },
  { path: '/devicegcs/log/:sn', name: 'Log Device GCS', component: LogDeviceGCS },
  { path: '/devicesearch', exact: true,  name: 'Search Device', component: DeviceSearch },
  { path: '/ticket/new', exact: true,  name: 'New Ticket', component: NewTicket },
  { path: '/ticket/readyreserved', exact: true,  name: 'Ready to Reserved', component: NewTicketReadyReserved },
  { path: '/ticket/progress', exact: true,  name: 'Progress Ticket', component: TicketProgress },
  { path: '/ticket/progress/:id/:type', exact: true,  name: 'Detail Ticket', component: TicketInfo },
  { path: '/ticket/report', exact: true,  name: 'Report Ticket', component: TicketReporting },
  { path: '/ticket/close', exact: true,  name: 'Close Ticket', component: CloseTicket },
  { path: '/test-connection', name: 'Test Connection', component: TestConnection },
  { path: '/uploadds', name:'Upload DS', component: UploadDS},
  { path: '/chartstatustoner', name:'History Pemakaian Consumable', component: ChartStatusToner},
  { path: '/chartstatustonergcs', name:'History Pemakaian Consumable', component: ChartStatusTonerGCS},
  { path: '/chartSample', name:'chart sample', component: ChartSample},
  { path: '/searchconsumable', name:'Search Consumable', component: SearchConsumable},
  { path: '/searchconsumableGCS', name:'Search Consumable', component: SearchConsumableGCS},
  { path: '/searchsn', name:'Search SN Toner & Drum', component: SearchSNTonerDrum}
  //{ path: '/switches', name:'Switches', component: Switches},
];

export default routes;
